import React, { Component } from 'react';
import logo from './../images/caja-registradora.png'
class getMsgboxCaja extends Component {
  render(){

      return (
        <React.Fragment>
        <div style={{"width":"100%","height":"100%","textAlign":"center","display":"flex","justifyContent":"center","alignItems":"center","position":"relative"}}> 
          <img src={logo} alt="Logo" style={{"width":"30%","maxWidth":"100%","maxHeight":"100%"}} />
          <div style={{"fontSize":"25px","position":"absolute","backgroundColor":"rgba(255, 255, 255, 0.9)","padding":"10px","borderRadius":"5px"}}>CAJA CERRADA</div>
        </div>
        </React.Fragment>
      )
  }
  componentDidMount() {
     this.props.validar_caja_activa();
  }
}

export default getMsgboxCaja;
